import React from 'react'
import { styled } from 'src/ui/theme'
import { Header, Body } from 'src/ui/typography'
import { TRewardCellData } from './types'
import { breakpoints, useDimensions } from 'src/ui/dimensions'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 255px;
  margin-right: 10px;

  &:last-child {
    margin-right: 0;
  }

  @media (max-width: ${breakpoints.mobile}px) {
    margin: 0;
    width: auto;
    min-width: 140px;
  }
`

const Grade = styled(Body)`
  color: ${({ theme }) => theme.colors.black.primary};
  margin-bottom: 10px;

  @media (max-width: ${breakpoints.mobile}px) {
    margin-bottom: 4px;
    font-size: 14px;
  }
`

const Sum = styled(Header)`
  color: ${({ theme }) => theme.colors.black.primary};
`

type Props = {
  rewardData: TRewardCellData
}

export const RewardCell: React.FC<Props> = ({ rewardData }) => {
  const { grade, sum } = rewardData
  const { isMobile } = useDimensions()

  const sumFontSize = isMobile ? 'h5' : 'h4'

  return (
    <Wrapper>
      <Grade>{grade}</Grade>
      <Sum size={sumFontSize}>{sum}</Sum>
    </Wrapper>
  )
}
